import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Api from "../api/Api";
import Form from "../controls/Form";
import Input from "../controls/Input";
import Select from "../controls/Select";
import Checkbox from "../controls/Checkbox";
import Page from "../layout/Page";
import Confirm from "../layout/Confirm";

export default function User() {

	const { id } = useParams();
	const form = useRef();
	const [user, setUser] = useState(null);
	const [roles, setRoles] = useState(null);
	const [departments, setDepartments] = useState(null);

	useEffect(() => {
		Api.put('users/getuser', { id: id }, response => {
			setUser(response.data.user);
			setRoles(response.data.roles);
			setDepartments(response.data.departments.map(d => [d.id, d.name]));
		});
	}, [id]);

	const states = [
		[1, t.commonActive],
		[2, t.commonInactive],
	]

	const roleTypes = [
		["Vendor", true],
		["Customer", true],
		["ManagerVendor", true],
		["ManagerCustomer", true],
		["Compliance", false],
		["QRVI", false],
		["FinancialControlling", false],
		["FinancialDirecor", false],
		["Admin", false],
	];

	const back = Api.getParameter("back", "/users");

	const deleteUser = () => {
		Confirm(() => {
			Api.put('users/deleteuser', { id: id }, null, back);
		});
	}


	const globalChanged = (role, val, allowDepartments) => {
		setRoles(prev => {
			let res = { ...prev };
			if (val) res[role] = [];
			else delete res[role];
			return res;
		});
	}

	const roleChanged = (role, val) => {
		setRoles(prev => {
			let res = { ...prev };
			if (val.length) res[role] = val;
			else delete res[role]
			return res;
		})
	}

	const role = (role, allowDepartments) => {
		return (
			<div key={role} className="row gx-1 mb-2">
				<div className="col-lg-2 my-2">{T('role' + role)}</div>
				<div className="col-lg-2 my-2">
					<Checkbox label={allowDepartments ? t.userGlobal : null} name={role + "Global"} value={roles[role]?.length == 0} onChange={(val) => globalChanged(role, val, allowDepartments)} />
				</div>
				{(roles[role]?.length != 0 && allowDepartments) ? <div className="col-lg-8">
					<Select isint name={role + "Departments"} options={departments} value={roles[role] || []} onChange={(val) => roleChanged(role, val)} sortAZ multiple />
				</div> : null}
			</div>
		);
	}

	const fillValues = (values, addError) => {
		roleTypes.map(r => {
			delete values[r[0] + 'Global'];
			delete values[r[0] + 'Departments'];
		});
		values.roles = roles;
		return true;
	}

	let actions = <span onClick={deleteUser} className={"btn btn-sm btn-warning" + (!user?.canBeDeleted ? " disabled" : "")}><em className="fa fa-trash"></em> {t.commonDelete}</span>;

	return (
		<Page title='commonUser' back={back} submitForm={() => form} actions={actions}>
			{user && <Form action="users/saveuser" beforeSubmit={fillValues} redirectOnSuccess={back} ref={form}>
				<Input name="Id" type="hidden" value={id} />
				<div className="card bg-white">
					<div className="card-body">
						<div className="row gx-1 mb-2">
							<div className="col-lg-3">
								<Input name="FirstName" label={t.userFirstName} type="text" value={user.firstName} required />
							</div>
							<div className="col-lg-3">
								<Input name="LastName" label={t.userLastName} type="text" value={user.lastName} required />
							</div>
							<div className="col-lg-3">
								<Input name="Email" label={t.userEmail} type="email" value={user.email} required />
							</div>
							<div className="col-lg-3">
								<Select isint name="State" label={t.commonState} options={states} value={user.state} required />
							</div>
						</div>
						{roleTypes.map(r => role(r[0], r[1]))}
					</div>
				</div>
			</Form>}
		</Page>
	);
}